( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('ContactCustomService', ContactCustomService);

    ContactCustomService.$inject = ['$http'];

    function ContactCustomService( $http ) {
        var service = {
            returnContactsByCompany: returnContactsByCompany,
            returnContact: returnContact
        }

        return service;

        function returnContactsByCompany( id ) {
            var url = "api/contacts/company/" + id;
            return $http.get( url );
        }

        function returnContact( id, contact ) {
            var url = "api/contact?id=" + id + "&name=" + contact;
            return $http.get( url );
        }
    }

})();
